import { useEffect, useRef } from "react"

/**
 * A forward goes to new people, so it starts with no Cc or Bcc. Reply-all can
 * fill those from the original email before the agent switches to forward.
 */
export function useResetRecipientsOnForward(
	isForwardMode: boolean,
	clearRecipients: () => void,
) {
	const wasForwardMode = useRef(isForwardMode)

	useEffect(() => {
		if (isForwardMode && !wasForwardMode.current) clearRecipients()
		wasForwardMode.current = isForwardMode
	}, [isForwardMode, clearRecipients])
}
